import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)
const test = resolve => require(['view/test'], resolve)
const error = resolve => require(['view/notFound'], resolve)
const maps = resolve => require(['view/maps/index'], resolve)
const third_token = resolve => require(['view/pay/third_token'], resolve)
const home = resolve => require(['view/home/home'], resolve)
const switchs = resolve => require(['view/home/switchs'], resolve)
const history = resolve => require(['view/search/history'], resolve)
const tourBooking = resolve => require(['view/tour/booking'], resolve)
const tourList = resolve => require(['view/tour/list'], resolve)
const tourSearch = resolve => require(['view/tour/search'], resolve)
const tourInfo = resolve => require(['view/tour/info'], resolve)
const tourPrintItinerary = resolve => require(['view/tour/print_itinerary'], resolve)

const tourCustomize = resolve => require(['view/tour/customize'], resolve)
const tourQueryVoucher = resolve => require(['view/tour/query_voucher'], resolve)


const tourCategory = resolve => require(['view/tour/category'], resolve)
const tourCategoryAll = resolve => require(['view/tour/category_all'], resolve)
const tourOrderInfo = resolve => require(['view/order/tour'], resolve)
const myTourReview = resolve => require(['view/my/tour/review'], resolve)
const myTourFree_pick = resolve => require(['view/my/tour/free_pick'], resolve)
const myTourOrderList = resolve => require(['view/my/tour/order'], resolve)
const goodsList = resolve => require(['view/goods/list'], resolve)
const goodsInfo = resolve => require(['view/goods/info'], resolve)
const goodsStore = resolve => require(['view/goods/store'], resolve)
const goodsGroupbuy = resolve => require(['view/goods/info'], resolve)
const goodsCart = resolve => require(['view/goods/cart'], resolve)
const goodsCheckout = resolve => require(['view/goods/checkout'], resolve)
const goodsSearch = resolve => require(['view/goods/search'], resolve)
const goodsCategory = resolve => require(['view/goods/category'], resolve)
const goodsCategoryAll = resolve => require(['view/goods/category_all'], resolve)
const goodsOrderInfo = resolve => require(['view/order/goods'], resolve)
const goodsOrderMu = resolve => require(['view/order/goods_mu'], resolve)
const rechargeOrder = resolve => require(['view/order/recharge'], resolve)
const onlineOrderInfo = resolve => require(['view/order/online'], resolve)

const orderInvoice = resolve => require(['view/order/invoice'], resolve)
const orderVoucher = resolve => require(['view/order/voucher'], resolve)
const leaderApply = resolve => require(['view/goods/leader/apply'], resolve)
const leaderArea = resolve => require(['view/goods/leader/delivery_area'], resolve)
const leaderMain = resolve => require(['view/my/leader/main'], resolve)
const leaderOrder = resolve => require(['view/my/leader/order'], resolve)
const leaderScan = resolve => require(['view/my/leader/scan'], resolve)
const leaderInfo = resolve => require(['view/my/leader/info'], resolve)
const leaderReceiveUser = resolve => require(['view/my/leader/receive_user'], resolve)
const leaderGroupSales = resolve => require(['view/my/leader/group_sales'], resolve)
const leaderBindUser = resolve => require(['view/my/leader/bind_user'], resolve)
const leaderApplyReceive = resolve => require(['view/my/leader/apply_receive'], resolve)


const myGoodsReview = resolve => require(['view/my/goods/review'], resolve)
const myGoodsRefund = resolve => require(['view/my/goods/refund'], resolve)
const myGoodsOrderList = resolve => require(['view/my/goods/order'], resolve)
const Article = resolve => require(['view/article/info'], resolve)
const News = resolve => require(['view/news/info'], resolve)
const NewsList = resolve => require(['view/news/list'], resolve)
const NewsSearch = resolve => require(['view/news/search'], resolve)
const Coupons = resolve => require(['view/coupons/index'], resolve)
const login = resolve => require(['view/member/login'], resolve)
const register = resolve => require(['view/member/register'], resolve)
const forgotPw = resolve => require(['view/member/forgotPw'], resolve)
const access_token = resolve => require(['view/member/access_token'], resolve)
const orderMain = resolve => require(['view/order/main'], resolve)
const myMain = resolve => require(['view/my/main'], resolve)
const myProfile = resolve => require(['view/my/user/profile'], resolve)
const myTel = resolve => require(['view/my/user/tel'], resolve)
const myPayPwd = resolve => require(['view/my/user/pay_password'], resolve)
const myEmail = resolve => require(['view/my/user/email'], resolve)
const myBill = resolve => require(['view/my/user/bill'], resolve)
const myDrawApply = resolve => require(['view/my/user/draw_apply'], resolve)
const myPassword = resolve => require(['view/my/user/password'], resolve)
const myFavorate = resolve => require(['view/my/user/favorate'], resolve)
const myNotice = resolve => require(['view/my/user/notice'], resolve)
const myCoupon = resolve => require(['view/my/user/coupon'], resolve)
const myReceive = resolve => require(['view/my/user/receive'], resolve)

export default [
  //test
  {
    name: 'test',
    path: '/test',
    component: resolve => require(['view/test/index'], resolve),
    children: [{
      name: 'test/p1',
      path: '/test/p1',
      component: resolve => require(['components/skeleton/home'], resolve),
    }, {
      name: 'test/p2',
      path: '/test/p2',
      component: resolve => require(['components/skeleton/p2'], resolve),
    }, {
      name: 'test/p3',
      path: '/test/p3',
      component: resolve => require(['components/skeleton/p3'], resolve),
    }, {
      name: 'test/base',
      path: '/test/base',
      component: test
    }, {
      name: 'test/scroller',
      path: '/test/scroller',
      component: resolve => require(['view/test/scroller'], resolve)
    }, ]
  }, {
    name: 'maps',
    path: '/maps',
    component: maps
  }, {
    name: 'pay/third_token',
    path: '/pay/third_token',
    component: third_token
  }, {
    name: 'home',
    path: '',
    component: home,
    meta: {
      keepAlive: true,
      scrollTop: 0,
      name:''
    }
  }, {
    name: 'switchs',
    path: '/switchs',
    component: switchs
  }, {
    name: 'coupons',
    path: '/coupons',
    component: Coupons
  },
  //文章
  {
    name: 'article/initial',
    path: '/article/:initial(\.+)?',
    component: Article
  },
  //新闻
  {
    name: 'news/search',
    path: '/news/search/:query(\.+)?',
    component: NewsSearch,
  }, {
    name: 'news/id',
    path: '/news/:id(\\d+)',
    component: News
  }, {
    path: '/news/:initial(\.+)?',
    component: NewsList,
  }, {
    name: 'search/query',
    path: '/search/:query(\.+)?',
    component: history
  },
  //旅游
  {
    name: 'tour/search/query',
    path: '/tour/search/:query(\.+)?',
    component: tourSearch,
  }, {
    name: 'tours/initial',
    path: '/tours/:initial(\.+)?',
    component: tourList,
  }, {
    name: 'tour/id/query',
    path: '/tour/:id(\\d+)/:query(\.+)?',
    component: tourInfo,
  },{
    name: 'tour/print_itinerary/id/query',
    path: '/tour/print_itinerary/:id(\\d+)/:query(\.+)?',
    component: tourPrintItinerary,
  },{
    name: 'tour/customize',
    path: '/tour/customize',
    component: tourCustomize,
  },{
    name: 'tour/query_voucher',
    path: '/tour/query_voucher',
    component: tourQueryVoucher,
  }, {
    name: 'tour/booking/query',
    path: '/tour/booking/:query(\.+)?',
    component: tourBooking,
  }, {
    name: 'tour/category/query',
    path: '/tour/category/:query(\.+)?',
    component: tourCategory,
  },{
    name: 'tour/category_all/query',
    path: '/tour/category_all/:query(\.+)?',
    component: tourCategoryAll,
     meta: {
      keepAlive: true,
      scrollTop: 0,
      name:'.flex-col-auto'
    }
  },
  //商品
  {
    name: 'goods/id/query',
    path: '/goods/:id(\\d+)/:query(\.+)?',
    component: goodsInfo,
  }, {
    name: 'goods/groupbuy/id/query',
    path: '/goods/groupbuy/:id(\\d+)/:query(\.+)?',
    component: goodsGroupbuy,
  }, {
    name: 'goods/cart',
    path: '/goods/cart(/)?:id(\\d?)',
    component: goodsCart,
  }, {
    name: 'goods/checkout/type/orderid',
    path: '/goods/checkout/:type(\.+)?/:orderid(\.+)?',
    component: goodsCheckout,
  }, {
    name: 'goods/search/query',
    path: '/goods/search/:query(\.+)?',
    component: goodsSearch,
  }, {
    name: 'goods/category/query',
    path: '/goods/category/:query(\.+)?',
    component: goodsCategory,
  }, {
    name: 'goods/category_all/query',
    path: '/goods/category_all/:query(\.+)?',
    component: goodsCategoryAll,
    meta: {
      keepAlive: true,
      scrollTop: 0,
      name:'.flex-col-auto'
    }
  }, {
    name: 'goodss/initial',
    path: '/goodss/:initial(\.+)?',
    component: goodsList,
  }, {
    name: 'delivery_area',
    path: '/delivery_area',
    component: leaderArea,
    meta: {
      keepAlive: true,
      scrollTop: 0,
      name:'.flex-col-auto'
    }
  }, {
    name: 'store',
    path: '/store',
    component: goodsStore,
  }, {
    name: 'storeindex',
    path: '/store/index',
    component: goodsStore,
  }, {
    name: 'leader/apply',
    path: '/leader/apply',
    component: leaderApply,
    meta: {
      requiresAuth: true
    },
  },
  //订单
  {
    name: 'order',
    path: '/order/',
    component: orderMain,
    meta: {
      requiresAuth: true
    },
    children: [{
      name: 'order/online/id/query',
      path: 'online/:id(\\d+)/:query(\.+)?',
      component: onlineOrderInfo,
      meta: {
          passAuth:true,
        },
    },{
      name: 'order/invoice/id',
      path: 'invoice/:id(\.+)',
      component: orderInvoice,
       meta: {
          passAuth:true,
        },
    },{
      name: 'order/voucher/id',
      path: 'voucher/:id(\.+)',
      component: orderVoucher,
       meta: {
          passAuth:true,
        },
    }, {
      name: 'order/tour/id/query',
      path: 'tour/:id(\\d+)/:query(\.+)?',
      component: tourOrderInfo,
      meta: {
          passAuth:true,
        },
    }, {
      name: 'order/goods/id/query',
      path: 'goods/:id(\\d+)/:query(\.+)?',
      component: goodsOrderInfo,
    }, {
      name: 'order/goods_mu_o/id',
      path: 'goods_mu_o/:id(\\d+)',
      component: goodsOrderMu,
    }, {
      name: 'order/goods_mu/id',
      path: 'goods_mu/:id(\.+)',
      component: goodsOrderMu,
    }, {
      name: 'order/recharge_pay/id',
      path: 'recharge_pay/:id(\.+)?',
      component: rechargeOrder,
    }, {
      name: 'order/recharge/id',
      path: 'recharge/:id(\.+)',
      component: rechargeOrder,
    }]
  },
  //用户模块
  {
    name: 'member/login',
    path: '/member/login',
    component: login,
  }, {
    name: 'member/register',
    path: '/member/register',
    component: register,
  }, {
    name: 'member/access_token/query',
    path: '/member/access_token/:query(\.+)?',
    component: access_token,
  }, {
    name: 'member/forgot_pwd/act',
    path: '/member/forgot_pwd/:act(\.+)?/:e(\.+)?/:email(\.+)?',
    component: forgotPw
  },
  //个人信息页
  {
    name: 'my',
    path: '/my/',
    component: myMain,
    meta: {
      requiresAuth: true,
    },
    children: [{
      name: 'my/user/profile',
      path: 'user/profile',
      component: myProfile
    }, {
      name: 'my/user/tel',
      path: 'user/tel',
      component: myTel
    }, {
      name: 'my/user/pay_password',
      path: 'user/pay_password',
      component: myPayPwd
    }, {
      name: 'my/user/email',
      path: 'user/email',
      component: myEmail
    }, {
      name: 'my/user/password',
      path: 'user/password',
      component: myPassword
    }, {
      name: 'my/user/bill/query',
      path: 'user/bill/:query(\.+)?',
      component: myBill
    }, {
      name: 'my/user/draw_apply/query',
      path: 'user/draw_apply/:query(\.+)?',
      component: myDrawApply
    }, {
      name: 'my/user/favorate/query',
      path: 'user/favorate/:query(\.+)?',
      component: myFavorate
    }, {
      name: 'my/user/notice/query',
      path: 'user/notice/:query(\.+)?',
      component: myNotice
    }, {
      name: 'my/user/coupon/query',
      path: 'user/coupon/:query(\.+)?',
      component: myCoupon
    }, {
      name: 'my/user/receive/query',
      path: 'user/receive/:query(\.+)?',
      component: myReceive
    }, {
      name: 'my/order/tour/query',
      path: 'order/tour/:query(\.+)?',
      component: myTourOrderList
    }, {
      name: 'my/tour/review/query',
      path: 'tour/review/:query(\.+)?',
      component: myTourReview,
    }, {
      name: 'my/tour/free_pick/query',
      path: 'tour/free_pick/:query(\.+)?',
      component: myTourFree_pick,
    }, {
      name: 'my/order/goods/query',
      path: 'order/goods/:query(\.+)?',
      component: myGoodsOrderList
    }, {
      name: 'my/goods/review/query',
      path: 'goods/review/:query(\.+)?',
      component: myGoodsReview,
    }, {
      name: 'my/order/goods_refund/query',
      path: 'order/goods_refund/:query(\.+)?',
      component: myGoodsRefund,
    }, {
      name: 'my/leader/main',
      path: 'leader/main',
      component: leaderMain
    }, {
      name: 'my/leader/info/query',
      path: 'leader/info/:query(\.+)?',
      component: leaderInfo
    }, {
      name: 'my/leader/receive_user/query',
      path: 'leader/receive_user/:query(\.+)?',
      component: leaderReceiveUser
    }, {
      name: 'my/leader/order/query',
      path: 'leader/order/:query(\.+)?',
      component: leaderOrder
    }, {
      name: 'my/leader/scan/query',
      path: 'leader/scan/:query(\.+)?',
      component: leaderScan
    }, {
      name: 'my/leader/group_sales/query',
      path: 'leader/group_sales/:query(\.+)?',
      component: leaderGroupSales
    }, {
      name: 'my/leader/bind_user/query',
      path: 'leader/bind_user/:query(\.+)?',
      component: leaderBindUser
    }, {
      name: 'my/leader/apply_receive/query',
      path: 'leader/apply_receive/:query(\.+)?',
      component: leaderApplyReceive
    }]
  }, {
    name: '404',
    path: '/404',
    component: error
  }, {
    name: 'all',
    path: '*',
    redirect: '/404'
  },
]
